<template>
  <div id="sign-in">
    <div class="section">
      <div class="columns">
        <div class="column is-half-desktop is-offset-one-quarter-desktop">
          <h1 class="subtitle">ログイン</h1>
          <SingInEmail></SingInEmail>
          <div class="content is-size-7">
            <ul>
              <li>パスワードを忘れた場合は
                <router-link to="/forgot-password">こちら</router-link>。</li>
              <li>初めてご利用の方は
                <router-link to="/signup">新規会員登録</router-link>
                してください。</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half-desktop is-offset-one-quarter-desktop">
          <p class="orline">または</p>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half-desktop is-offset-one-quarter-desktop">
          <h2 class="has-text-centered">外部サービスでログイン</h2>
          <div id="firebaseui-auth-container" />
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import SingInEmail from '@/components/SignInEmail';
import { db } from '@/plugins/firebase';

// TODO: plugins/firebase.js からだと使えないです。
import firebase from 'firebase';

//NOTE: Veturに怒られていますが、こうしないと動きません。
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css'

export default {
  name: 'SignIn',
  components: {
    SingInEmail
  },
  mounted() {
    const uiconfig = {
      callbacks: {
        signInSuccessWithAuthResult: () => {
          this.$router.push('/');
        },
        signInFailure: () => {
          alert('sign in failure');
        }
      },
      signInFlow: 'popup',
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      ],
    }
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth())
    ui.start('#firebaseui-auth-container', uiconfig);
  },
  data() {
    return {};
  },
  async created() {},
  methods: {
    async isInitialSignup(token) {
      const userDoc = await db.collection('users').doc(token).get();
      return !userDoc.exists;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
